<div class="ui-g-12 screen-flow" style="background-color: #efefef !important">
  <div class="ui-g" style="border-bottom: 1px solid black; background-color: white">
    <a class="navbar-brand egd-navbar-brand d-md-block d-sm-block" href="javascript:void(0)"
      (click)="openBaseLink('HOMPAGE_BASE_URL', '', '_self')">
      <img src="./assets/images/logo.png" class="egd-navbar-logo" alt="eGlobalDoctors - Care for better life" />
    </a>
  </div>
  <p-tabView [activeIndex]="this.consultationWorkflowData.currentScreenIndex" styleClass="custom-tabview">
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="consultation form" class="full-screen">
      <form #basicForm="ngForm" autocomplete="off" (ngSubmit)="this.buttonConfigs[0].action()" accept-charset="UTF-8"
        id="basic_form">
        <div class="ui-g-2 um-sm-12"></div>
        <div class="ui-g-8 ui-sm-12" style="
            padding: 10px;
            background-color: white;
            align-items: center;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          ">
          <div style="display: flex; justify-content: flex-end">
            <i class="pi pi-times" style="cursor: pointer; font-size: 100%"
              [routerLink]="['/', this.slug, 'book-appointment']"></i>
          </div>
          <div class="ui-g">
            <div class="ui-g-7 ui-sm-12 bdr">
              <div class="ui-g-12">
                <div style="display: flex;align-items: first baseline;margin-top: 10px;">
                  <div style="font-size: 17px;font-weight: bold;">
                    <p>Choose Language : </p>
                  </div>
                  <select class="notranslate customize-dropdown" [(ngModel)]="selectedLanguage"
                    (change)="translatePage($event)"
                    style="border: 2px solid lightgray;border-radius: 5px;padding: 10px;margin-left:15px;">
                    <option *ngFor="let option of languageOptions" [value]="option.code">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="ui-g-12">
                <p class="common_txt" style="font-weight: bold; margin-bottom: 7px">
                  Choose Consultation Type
                </p>
                <div class="ui-g-5 ui-md-5 ui-sm-12 clickable-box" style="
                    border: 2px solid lightgray;
                    border-radius: 5px;
                    word-wrap: break-word;
                    overflow: hidden;
                  " *ngIf="!this.is_uk_country">
                  <label class="form-check-label-box text-center">
                    <input class="form-check-input left_space" [value]="
                        this.consultationWorkflowData.consultation_data
                          .const_data.CONSULTATION_TYPES
                          .PRIMARY_MEDICAL_CONSULTATION
                      " [(ngModel)]="
                        this.consultationWorkflowData.consultation_data
                          .consultApiData.consultation_type_id
                      " type="radio" id="consultation_type_primary" name="consultation_types" required />
                    <span class="common_txt left_space">Primary Consultation</span>
                  </label>
                </div>
                <div class="ui-g-1 ui-sm-12"></div>
                <div class="ui-g-5 ui-md-5 ui-sm-12 clickable-box" style="
                    border: 2px solid lightgray;
                    border-radius: 5px;
                    word-wrap: break-word;
                    overflow: hidden;
                  ">
                  <label class="form-check-label-box text-center">
                    <input class="form-check-input" [value]="
                        this.consultationWorkflowData.consultation_data
                          .const_data.CONSULTATION_TYPES
                          .EXPERT_SECOND_MEDICAL_CONSULTATION"
                      [(ngModel)]="this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id"
                      type="radio" id="consultation_type_second" name="consultation_types" required />
                    <span class="common_txt left_space text-center" *ngIf="!this.is_uk_country">Second Opinion</span>
                    <span class="common_txt left_space text-center" *ngIf="this.is_uk_country">Specialist
                      Consultation</span>
                  </label>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-g-5 ui-md-5 ui-sm-12 clickable-box" style="
                    border: 2px solid lightgray;
                    border-radius: 5px;
                    word-wrap: break-word;
                    overflow: hidden;
                  " *ngIf="!this.is_uk_country">
                  <label class="form-check-label-box text-center">
                    <input class="form-check-input" [value]="
                        this.consultationWorkflowData.consultation_data
                          .const_data.CONSULTATION_TYPES
                          .MULTI_SPECIALTY_CONSULTATION
                      " [(ngModel)]="
                        this.consultationWorkflowData.consultation_data
                          .consultApiData.consultation_type_id
                      " type="radio" id="consultation_types" name="consultation_types" required />
                    <span class="common_txt left_space text-center">Multi Speciality</span>
                  </label>
                </div>
                <div class="ui-g-1"></div>
                <div class="ui-g-5" style="border: 2px solid lightgray;border-radius: 5px;" *ngIf="!this.is_uk_country">
                  <div class="form-check common_txt">
                    <input class="form-check-input"
                      [value]="this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION"
                      [(ngModel)]="this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id"
                      type="radio" id="consultation_types" name="consultation_types" required>
                    <label class="form-check-label" for="radio4">
                      <span style="margin-left: 5px;"></span>
                      Diet Consultation
                    </label>
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <p class="common_txt" style="font-weight: bold; margin-bottom: 7px">
                  Mention your symptom or health problem
                </p>
                <div class="ui-g-11 ui-sm-12" style="padding: 0;">
                  <textarea class="form-control common_txt" placeholder="Enter your symptom" #desc="ngModel"
                    id="condition_description" name="condition_description" [(ngModel)]="
                      this.consultationWorkflowData.consultation_data
                        .consultApiData.condition_description
                    " style="
                      font-family: Montserrat, sans-serif;
                      border: 2px solid lightgray;
                      border-radius: 5px;
                      padding: 10px;
                      width: 100%;
                    " required></textarea>
                </div>
                <div *ngIf="desc.invalid && (desc.dirty || desc.touched)" class="ui-g-12">
                  <div *ngIf="desc.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                    Symptom or Health problem is required.
                  </div>
                </div>
              </div>



              <div class="ui-g-12">
                <p class="common_txt" style="font-weight: bold; margin-bottom: 5px">
                  Mobile Number
                </p>
                <div class="input-group">
                  <div class="ui-lg-3 ui-md-5 ui-sm-5">
                    <p-dropdown id="choose_country_code" [options]="
                        this.consultationWorkflowData.patientreg.other_data
                          .countries
                      " name="speciality" [filter]="true" [filterBy]="'label'" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.other_data
                          .selected_country_acronym
                      " (ngModelChange)="onChangeCountry()" placeholder="Select" #country="ngModel"
                      styleClass="common_txt drop-country" [required]="true">
                    </p-dropdown>
                  </div>
                  <div class="ui-lg-8 ui-md-11 ui-sm-7">
                    <input type="text" id="mobile_number" name="mobile_number" class="form-control common_txt"
                      placeholder="Mobile Number" #mobile_number="ngModel" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.other_data
                          .primary_contact_no
                      " style="
                        border: 2px solid lightgray;
                        border-radius: 5px;
                        padding: 10px;
                      " required />
                  </div>
                </div>
                <div *ngIf="
                    mobile_number.invalid &&
                    (mobile_number.dirty || mobile_number.touched)
                  " class="ui-g-12">
                  <div *ngIf="mobile_number.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                    Mobile Number is required.
                  </div>
                </div>
                <p class="common_txt" style="color: gray">
                  A verification code will be sent to this number.
                </p>
              </div>
              <div class="ui-g-12 cont_button">
                <button pButton type="submit" label="Continue" [disabled]="!basicForm.valid || isPosting()" style="
                    margin:5px 5px 10px 0px;
                    width: 160px;
                    border-radius: 5px;
                    padding: 10px;
                  "></button>
              </div>

              <div class="ui-g-12">
                <div class="ui-g-12">
                  <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                  </app-loading>
                </div>
                <app-error-messages class="ui-g-12" [api_result]="
                    this.consultationWorkflowData.phones_exists_response
                  "></app-error-messages>
              </div>
            </div>

            <div class="ui-g-5 ui-sm-12 visible_screens" style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              ">
              <img src="../../../../assets/images/5063407.png" alt="image" style="max-width: 80%; height: auto" />
              <br />
              <div style="
                  max-width: 350px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center; ;
                ">
                <p class="common_txt" style="font-weight: bold">
                  Digital Video Consultations from
                </p>
                <p class="common_txt" style="font-weight: bold">
                  Anywhere with 24*7 Customer Support
                </p>
              </div>
            </div>
          </div>

        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Login">
      <div class="ui-g-2 ui-sm-12"></div>
      <div class="ui-g-8 ui-sm-12" style="
          padding: 10px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          align-items: center;
        ">
        <div style="margin-bottom: 10px; display: flex">
          <img src="../../../../assets/images/ad_landing_page_assets/Icon ionic-ios-arrow-round-back.png" style="
              margin-right: 5px;
              height: auto;
              width: auto;
              cursor: pointer;
            " (click)="goBack()" />
          <i class="pi pi-times" style="cursor: pointer; font-size: 100%; margin-left: auto"
            [routerLink]="['/', this.slug, 'book-appointment']"></i>
        </div>
        <ng-container>
          <div class="ui-g">
            <form #otpForm="ngForm" (ngSubmit)="this.buttonConfigs[1].action()" accept-charset="UTF-8" id="login_form">
              <div class="ui-g-7 ui-sm-12 bdr">
                <div class="ui-g-12 ui-sm-12">
                  <div style="margin-bottom: 10px">
                    <p class="common_txt" style="font-weight: bold">
                      Just a step away from booking your consultation
                    </p>
                  </div>
                </div>
                <div class="ui-g-12" *ngIf="!this.consultationWorkflowData.edit_phone_no">
                  <p class="common_txt"> We have sent an OTP on </p>
                </div>
                <div *ngIf="!this.consultationWorkflowData.edit_phone_no" class="ui-g-12 common_txt1"
                  style="font-weight: bold;font-size: 24px;">
                  <span>{{ this.consultationWorkflowData.phone_exists_api_data.primary_contact_number }} <i
                      type="button" label="Edit" class="pi pi-pencil" (click)="this.editPhoneNumber()"
                      style="color: black;"></i></span>
                </div>
                <div class="ui-g-12" *ngIf="this.consultationWorkflowData.edit_phone_no">
                  <form #basicForm="ngForm" autocomplete="off" (ngSubmit)="this.buttonConfigs[0].action()"
                    accept-charset="UTF-8" id="basic_form">
                    <p class="common_txt" style="font-weight: bold; margin-bottom: 5px">
                      Mobile Number
                    </p>
                    <div class="input-group">
                      <div class="ui-lg-3 ui-md-3 ui-sm-5">
                        <p-dropdown id="choose_country_code" [options]="
                          this.consultationWorkflowData.patientreg.other_data
                            .countries
                        " name="speciality" [filter]="true" [filterBy]="'label'" [(ngModel)]="
                          this.consultationWorkflowData.patientreg.other_data
                            .selected_country_acronym
                        " (ngModelChange)="onChangeCountry()" placeholder="Select" #country="ngModel"
                          styleClass="common_txt drop-country" [required]="true">
                        </p-dropdown>
                      </div>
                      <div class="ui-lg-5 ui-md-5 ui-sm-7">
                        <input type="text" id="mobile_number" name="mobile_number" class="form-control common_txt"
                          placeholder="Mobile Number" #mobile_number="ngModel" [(ngModel)]="
                          this.consultationWorkflowData.patientreg.other_data
                            .primary_contact_no
                        " style="
                          border: 2px solid lightgray;
                          border-radius: 5px;
                          padding: 10px;
                        " required />
                      </div>
                      <div class="ui-lg-4 ui-md-4 ui-sm-12 text-center">
                        <button pButton type="submit" label="Send Otp" [disabled]="!basicForm.valid || isPosting()"
                          style="
                        
                        width: 160px;
                        border-radius: 5px;
                        padding: 5px;
                      "></button>
                      </div>
                    </div>
                    <div *ngIf="
                      mobile_number.invalid &&
                      (mobile_number.dirty || mobile_number.touched)
                    " class="ui-g-12">
                      <div *ngIf="mobile_number.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                        Mobile Number is required.
                      </div>
                    </div>
                    <p class="common_txt" style="color: gray">
                      A verification code will be sent to this number.
                    </p>
                    <div class="ui-g-12 text-center">
                      <p type="button" style="font-weight: bolder;color: #004aad;" (click)="closeedit()">Cancel</p>
                    </div>
                  </form>

                </div>

                <ng-container
                  *ngIf="!this.consultationWorkflowData.phones_exists_response.Posting && !this.consultationWorkflowData.edit_phone_no">
                  <div class="ui-g-12 common_txt">
                    <otp-input class="ui-lg-12 ui-md-12 ui-sm-12 ml-1 notranslate" [isPrimeNg]="false" [otp_data]="
                      this.consultationWorkflowData.patientreg.api_data.otp_data
                    " (otp_resend)="otp_resend()" style="border-radius: 5px; margin-top: 0;" required>
                    </otp-input>
                  </div>
                </ng-container>
                <div class="ui-g-12" class="cont_button">
                  <div class="ui-lg-4 ui-sm-12 ui-md-8">
                    <button pButton type="submit"
                      [disabled]="!otpForm.valid || isPosting() || this.consultationWorkflowData.edit_phone_no" style="
                        width: 100%;
                        height: auto;
                        border-radius: 5px;
                        padding: 10px;
                      " label="Continue"></button>
                  </div>
                </div>

                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                  </div>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.patientreg.api_data.otp_data
                        .otp_api_result
                    "></app-error-messages>
                </div>
              </div>
              <div class="ui-g-5 ui-sm-12 text-center right_content visible_screens" style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
                <img src="../../../../assets/images/OBJECTS.png" alt="image" style="max-width: 90%; height: auto" />
                <div class="ui-lg-12 text-center common_txt" *ngIf="!this.is_uk_country">
                  <div class="ui-g-3 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>400+</b></p>
                    <p>Doctors</p>
                  </div>
                  <div class="ui-g-5 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>many</b></p>
                    <p>Specialities</p>
                  </div>
                  <div class="ui-g-4 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>8+</b></p>
                    <p>Countries</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Login and Register">
      <div class="ui-g-2 ui-sm-12"></div>
      <div class="ui-g-8 ui-sm-12" style="
          padding: 10px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          align-items: center;
        ">
        <div style="margin-bottom: 10px; display: flex">
          <img src="../../../../assets/images/ad_landing_page_assets/Icon ionic-ios-arrow-round-back.png" style="
              margin-right: 5px;
              height: auto;
              width: auto;
              cursor: pointer;
            " (click)="goBack()" />
          <i class="pi pi-times" style="cursor: pointer; font-size: 100%; margin-left: auto"
            [routerLink]="['/', this.slug, 'book-appointment']"></i>
        </div>
        <ng-container>
          <form #registerForm="ngForm" (ngSubmit)="this.buttonConfigs[2].action()" accept-charset="UTF-8"
            id="login_form">
            <div class="ui-g">
              <div class="ui-g-7 ui-sm-12 bdr">
                <p class="common_txt" style="font-weight: bold; margin-bottom: 15px">
                  Just a step away from booking your consultation
                </p>
                <div class="ui-g-12">
                  <p class="common_txt" style="font-weight: bold; margin-bottom: 10px">
                    Patient Name
                  </p>
                  <div class="ui-g-5 ui-sm-6">
                    <input type="text" class="form-control" placeholder="First Name" #first_name="ngModel"
                      id="first_name" name="first_name" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.api_data
                          .userPatientv2.first_name
                      " style="
                        border: 2px solid lightgray;
                        border-radius: 5px;
                        padding: 10px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                      " required />
                  </div>
                  <div class="ui-g-5 ui-sm-6">
                    <input type="text" class="form-control" placeholder="Last Name" #last_name="ngModel" id="last_name"
                      name="last_name" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.api_data
                          .userPatientv2.last_name
                      " style="
                        border: 2px solid lightgray;
                        border-radius: 5px;
                        padding: 10px;
                      " required />
                  </div>
                  <div *ngIf="
                      first_name.invalid &&
                      (first_name.dirty || first_name.touched)
                    " class="ui-g-12">
                    <div *ngIf="first_name.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                      First Name is required.
                    </div>
                  </div>
                  <div *ngIf="
                      last_name.invalid &&
                      (last_name.dirty || last_name.touched)
                    " class="ui-g-12">
                    <div *ngIf="last_name.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                      Last Name is required.
                    </div>
                  </div>
                </div>

                <!-- <div class="ui-g-12">
                                <p class="common_txt" style="font-weight: bold;margin-bottom: 10px;">Date of Birth</p>
                                <div>
                                    <input type="date" class="form-control" placeholder="DD/MM/YYYY" #dob="ngModel"
                                        [(ngModel)]="this.consultationWorkflowData.patientreg.api_data.userPatientv2.date_of_birth_date"
                                        style="border: 2px solid lightgray; border-radius: 5px; padding: 10px;">
                                </div>
                                <div *ngIf="(dob.invalid && (dob.dirty || dob.touched))" class="ui-g-12">
                                    <div *ngIf="dob.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                                        Date of birth is required.
                                    </div>
                                </div>
                            </div> -->

                <div class="ui-g-12">
                  <p class="common_txt" style="font-weight: bold; margin-bottom: 10px">
                    Country & State
                  </p>
                  <div class="ui-g-4 ui-sm-12">
                    <input type="text" class="form-control" placeholder="Country" #country="ngModel" id="country_name"
                      name="country_name" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.other_data
                          .selected_country_data.country_name
                      " style="
                        border: 2px solid lightgray;
                        border-radius: 5px;
                        padding: 10px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                      " disabled readonly />
                  </div>
                  <div class="ui-g-8 ui-sm-12">
                    <p-dropdown id="choose_state" [options]="
                        this.consultationWorkflowData.patientreg.other_data
                          .states
                      " name="speciality" [filter]="true" [filterBy]="'label'" [(ngModel)]="
                        this.consultationWorkflowData.patientreg.api_data
                          .userPatientv2.state_id
                      " placeholder="Select State" #state="ngModel" [required]="true">
                    </p-dropdown>
                    <div *ngIf="state.invalid && (state.dirty || state.touched)" class="ui-g-12">
                      <div *ngIf="state.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                        State is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ui-g-12">
                  <otp-input class="ui-lg-12 ui-md-12 ui-sm-12 ml-1" [isPrimeNg]="false" [otp_data]="
                      this.consultationWorkflowData.patientreg.api_data.otp_data
                    " (otp_resend)="otp_resend_register()" required>
                  </otp-input>
                </div>

                <div class="ui-g-12" class="cont_button">
                  <button pButton type="submit" label="Continue" class="contbtn"
                    [disabled]="!registerForm.valid || isPosting()" style="
                      margin: 10px 5px 10px 10px;
                      width: 200px;
                      border-radius: 5px;
                      padding: 10px;
                    "></button>
                </div>

                <!-- <div *ngIf="(desc.invalid && (desc.dirty || desc.touched))" class="ui-g-12">
                                    <div *ngIf="desc.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                                        OTP is required.
                                    </div>
                                </div> -->

                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                  </div>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.patientreg.api_data.otp_data
                        .otp_api_result
                    "></app-error-messages>
                </div>
              </div>

              <div class="ui-g-5 ui-sm-12 text-center right_content visible_screens" style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
                <img src="../../../../assets/images/OBJECTS.png" alt="image" style="max-width: 90%; height: auto" />
                <div class="ui-lg-12 text-center common_txt" *ngIf="!this.is_uk_country">
                  <div class="ui-g-3 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>400+</b></p>
                    <p>Doctors</p>
                  </div>
                  <div class="ui-g-5 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>many</b></p>
                    <p>Specialities</p>
                  </div>
                  <div class="ui-g-4 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>8+</b></p>
                    <p>Countries</p>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </ng-container>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Confirm and pay">
      <form #consultationForm="ngForm" autocomplete="off" (ngSubmit)="this.buttonConfigs[3].action()"
        accept-charset="UTF-8" id="basic_form">
        <div class="ui-g-2 ui-sm-12"></div>
        <div class="ui-g-8 ui-sm-12" style="
            padding: 10px;
            background-color: white;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            align-items: center;
          ">
          <div class="common_txt1" style="margin-bottom: 10px; display: flex; align-items: center">
            <img src="../../../../assets/images/ad_landing_page_assets/Icon ionic-ios-arrow-round-back.png" style="
                margin-right: 10px;
                max-height: 20px;
                max-width: 100%;
                cursor: pointer;
              " (click)="goBack()" />
            <p style="font-weight: bold; flex-grow: 1">Confirm & Pay</p>
            <i class="pi pi-times" style="cursor: pointer; font-size: 20px"></i>
          </div>

          <ng-container>
            <div class="ui-g">
              <div class="ui-g-7 ui-sm-12 bdr">
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-12">
                      <p class="common_txt" style="margin-bottom: 15px">
                        One of our specialist doctor will talk to you shortly.
                      </p>
                    </div>
                    <div class="ui-g-12">
                      <p class="common_txt" style="font-weight: bold; margin-bottom: 7px">
                        Choose your Speciality
                      </p>
                      <!-- Single-Specialty -->
                      <div *ngIf="!isMultiSpecialtyConsultation()" class="ui-g-5 ui-lg-5 ui-sm-12">
                        <p-dropdown id="choose_specialty" class="notranslate" [options]="
                            this.consultationWorkflowData.consultation_data.other_data
                              .specialty_data
                          " name="speciality" [filter]="true" [filterBy]="'label'" [(ngModel)]="
                            this.consultationWorkflowData.consultation_data.other_data
                              .selectedSpecialtyId
                          " (ngModelChange)="onSpecialityChange()" placeholder="Select" #speciality="ngModel"
                          [required]="true" [style]="{'min-width':'100% !important','margin':'0'}">
                        </p-dropdown>
                        <div *ngIf="
                            speciality.invalid &&
                            (speciality.dirty || speciality.touched)
                          " class="ui-g-12">
                          <div *ngIf="speciality.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                            Specialty is required.
                          </div>
                        </div>
                      </div>
                      <!-- Multi-Specialty -->
                      <div *ngIf="isMultiSpecialtyConsultation()" class="ui-g-5 ui-lg-5 ui-sm-12">
                        <p-multiSelect class="notranslate" id="choose_specialty" [options]="
                            this.consultationWorkflowData.consultation_data.other_data
                              .specialty_data
                          " name="speciality" [(ngModel)]="
                            this.consultationWorkflowData.consultation_data
                              .consultApiData.specialty_id
                          " (ngModelChange)="onSpecialityChange()" placeholder="Select" #speciality="ngModel"
                          [maxSelectedLabels]="2" [selectedItemsLabel]="'{0} items selected'" required>
                        </p-multiSelect>
                        <div *ngIf="
                            speciality.invalid &&
                            (speciality.dirty || speciality.touched)
                          " class="ui-g-12">
                          <div *ngIf="speciality.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                            Specialty is required.
                          </div>
                        </div>
                        <div *ngIf="
                            this.consultationWorkflowData.consultation_data
                              .consultApiData.specialty_id?.length > 0 &&
                            this.consultationWorkflowData.consultation_data
                              .consultApiData.specialty_id?.length <= 1
                          " class="ui-g-12 alert alert-danger" role="alert">
                          Please select at least 2 specialties.
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-6 ui-sm-12">
                      <p class="common_txt" style="font-weight: bold; margin-bottom: 7px">
                        Patient Name
                      </p>
                      <p-dropdown id="choose_member" class="notranslate" [(ngModel)]="
                        this.consultationWorkflowData.consultation_data
                          .consultApiData.patient_guid
                      " placeholder="Select" [filter]="true" filterBy="label" [options]="
                        this.consultationWorkflowData.consultation_data
                          .other_data.members_data
                      " #member="ngModel" name="member" (ngModelChange)="onMemberChange()" [required]="true">
                      </p-dropdown>
                      <div *ngIf="member.invalid && (member.dirty || member.touched)" class="ui-g-12">
                        <div *ngIf="member.errors.required" class="ui-g-12 alert alert-danger" role="alert">
                          Member selection is required.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-12"
                    *ngIf="
                    this.consultationWorkflowData.consultation_data.other_data.packages_status_data.length != 0 && !this.is_uk_country">
                    <p-radioButton name="payment_option" [value]="false" label="Use my Package" [(ngModel)]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .is_pay
                    " #payment_option="ngModel" (ngModelChange)="onPaymentChange()" required [disabled]="
                      isPosting() ||
                      this.consultationWorkflowData.consultation_data.other_data
                        .packageConsultDoctor.otherData.packagesDiabled">
                    </p-radioButton>
                    <p>
                      (By selecting the package 1 consultation will be used from
                      selected package)
                    </p>
                    <ng-container *ngIf="!isPay()">
                      <div class="ui-g pl-1rem" *ngFor="
                        let package of this.consultationWorkflowData
                          .consultation_data.other_data.packages_status_data
                      ">
                        <div class="ui-g-12">
                          <p-radioButton name="package_option" [value]="package.id" [label]="package.final_name"
                            [(ngModel)]="
                            this.consultationWorkflowData.consultation_data
                              .consultApiData.user_package_id
                          " (ngModelChange)="onUserPackageChange()" #package_option="ngModel" [disabled]="
                            isPosting() ||
                            this.consultationWorkflowData.consultation_data
                              .other_data.packageConsultDoctor.otherData
                              .packagesDiabled
                          " [required]="
                            !this.consultationWorkflowData.consultation_data
                              .other_data.is_pay
                          ">
                          </p-radioButton>
                          <p class="alert-success">
                            ({{ text(package.user_package_count) }})
                          </p>
                          <p class="alert-success">
                            (Valid Till -
                            {{ package.expires_at | date: ' MMM dd, YYYY ' }})
                          </p>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="ui-g-12 common_txt" style="margin-left: 5px;">
                    <p-radioButton name="payment_option" [value]="true" label="Pay for consultation" [(ngModel)]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .is_pay
                    " #payment_option="ngModel" (ngModelChange)="onPaymentChange()" required [disabled]="
                      isPosting() ||
                      this.consultationWorkflowData.consultation_data.other_data
                        .packageConsultDoctor.otherData.packagesDiabled
                    ">
                    </p-radioButton>
                  </div>

                  <div class="ui-g-12" *ngIf="isNutritionAndHealthConsultation()">
                    <p class="common_txt" style="font-weight: bold; margin-bottom: 7px">
                      Select Plan Type
                    </p>
                    <ng-container *ngFor="
                      let diet_consultation of this.consultationWorkflowData
                        .consultation_data.other_data.nutritionHealthCons.plans
                        .plans_list
                    ">
                      <div class="ui-lg-4 ui-md-6 ui-g-12">
                        <p-radioButton name="nutrition_and_health_consultation_type_id"
                          [value]="diet_consultation.value" [label]="diet_consultation.consultation_name" [(ngModel)]="
                          this.consultationWorkflowData.consultation_data
                            .other_data.selectedDietPlan
                        " #nutrition_and_health_consultation_type_id="ngModel" [disabled]="isPosting()" required>
                        </p-radioButton>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div *ngIf="!isPackageSpecialty()">
                  <div class="ui-g-12">
                    <ng-container *ngIf="
                      !this.consultationWorkflowData.consultation_data
                        .other_data.user_packages_list_api_result.Posting ||
                      this.consultationWorkflowData.consultation_data.other_data
                        .priority_list_api_result.Posting
                    ">
                      <ng-container *ngIf="
                        !isNutritionAndHealthConsultation() &&
                        this.consultationWorkflowData.consultation_data
                          .other_data.priority_list?.length > 0
                      ">
                        <div class="ui-g-12">
                          <div class="ui-g-12">
                            <p class="common_txt" style="font-weight: bold">
                              Doctor Origin
                            </p>
                          </div>

                          <div class="ui-g-12">
                            <div class="ui-g-12 ui-md-12 ui-lg-12 ui-sm-12 common_txt" *ngFor="
                              let priority of this.consultationWorkflowData
                                .consultation_data.other_data.priority_list
                            ">
                              <p-radioButton class="notranslate" name="consultation_priority_type_id"
                                id="consultation_priority_type_id" [value]="priority.id" [label]="
                                isPay()
                                  ? priority.price_label
                                  : priority.no_price_label
                              " [(ngModel)]="
                                this.consultationWorkflowData.consultation_data
                                  .consultApiData.priority_type_id
                              " #consultation_priority_type_id="ngModel" [disabled]="
                                isPosting() ||
                                this.consultationWorkflowData.consultation_data
                                  .other_data.packageConsultDoctor.otherData
                                  .priorityDisabled
                              " required>
                              </p-radioButton>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>

                <div class="ui-g-12" *ngIf="isPay()">
                  <div class="ui-g-12">
                    <div *ngIf="!consultationWorkflowData.showInput" (click)="toggleInput()">
                      <p class="egd-color common_txt" style="margin-right: 15px">
                        Have a coupon code?
                      </p>
                    </div>
                  </div>
                  <div *ngIf="consultationWorkflowData.showInput" class="ui-g-12">
                    <div class="ui-g-7 ui-sm-8">
                      <input type="text" class="form-control" placeholder="Write Coupon Code" #discount="ngModel"
                        id="discount" name="discount"
                        [(ngModel)]="this.consultationWorkflowData.consultation_data.other_data.coupon_code_data.discount_code_api.discount_code"
                        style="border: 2px solid lightgray; border-radius: 5px; padding: 10px;"
                        [disabled]="this.consultationWorkflowData.consultation_data.other_data.discount_applied" />
                    </div>
                    <div class="ui-g-5 ui-sm-4" style="margin-left: -10px;">
                      <button pButton type="button"
                        [label]="!this.consultationWorkflowData.consultation_data.other_data.discount_applied ? 'Apply' : 'Clear'"
                        (click)="discountCodeBtn()"
                        style="width: 100%; border: 2px solid lightgray; border-radius: 5px; padding: 5px; background-color: white; color: black;"></button>
                    </div>
                  </div>

                </div>
                <div class="ui-g-12 alert-success1" *ngIf="
                    this.consultationWorkflowData.consultation_data.other_data
                      .discount_applied
                  ">
                  {{
                  this.consultationWorkflowData.consultation_data.other_data
                  .discount_message
                  }}
                </div>
                <!-- <div class="ui-g-12">
                                    <div class="common_txt"><b>Final Fee</b></div>
                                    <br>
                                    <div class="common_txt1"><b>₹100</b></div>
                                </div> -->
                <div class="ui-g-12 common_txt cont_button">
                  <button pButton type="submit" label="Continue to Payment" style="
                      margin: 10px 5px 10px 10px;
                      width: 70%;
                      border-radius: 5px;
                      padding: 10px;
                    "></button>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                  </div>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .members_list_api_result
                    ">
                  </app-error-messages>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .discount_code_apply_api_result
                    ">
                  </app-error-messages>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .priority_list_api_result
                    ">
                  </app-error-messages>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .submit_consultation_api_result
                    ">
                  </app-error-messages>
                  <app-error-messages class="ui-g-12" [api_result]="
                      this.consultationWorkflowData.consultation_data.other_data
                        .payment_data.payment_start_api_result
                    ">
                  </app-error-messages>
                </div>
              </div>

              <div class="ui-g-5 ui-sm-12 text-center right_content visible_screens" style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            ">
                <img src="../../../../assets/images/OBJECTS.png" alt="image" style="max-width: 90%; height: auto" />
                <div class="ui-lg-12 text-center common_txt" *ngIf="!this.is_uk_country">
                  <div class="ui-g-3 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>400+</b></p>
                    <p>Doctors</p>
                  </div>
                  <div class="ui-g-5 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>many</b></p>
                    <p>Specialities</p>
                  </div>
                  <div class="ui-g-4 ui-sm-12 text-center">
                    <p class="egd-color notranslate"><b>8+</b></p>
                    <p>Countries</p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Payment">
      <div class="ui-g-2 ui-sm-12"></div>
      <div class="ui-g-8 ui-sm-12" style="
          padding: 10px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          align-items: center;
        ">
        <div style="margin-bottom: 10px; display: flex">
          <img src="../../../../assets/images/ad_landing_page_assets/Icon ionic-ios-arrow-round-back.png" style="
              margin-right: 5px;
              height: auto;
              width: auto;
              cursor: pointer;
            " (click)="goBack()" />
          <i class="pi pi-times" style="cursor: pointer; font-size: 100%; margin-left: auto"
            [routerLink]="['/', this.slug, 'book-appointment']"></i>
        </div>
        <ng-container>
          <div class="ui-g">
            <app-consultation-flow-payment class="ui-g-12" *ngIf="isPay()" [payment_data]="
                this.consultationWorkflowData.consultation_data.other_data
                  .payment_data
              " (payment_success)="onPaymentSuccess($event)"></app-consultation-flow-payment>
          </div>
        </ng-container>
      </div>
    </p-tabPanel>

    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Consultation Success">
      <ng-container *ngIf="isPay()">
        <p-dialog *ngIf="
            this.consultationWorkflowData.consultation_data.other_data
              .print_data.displayModal
          " header="Invoice" [(visible)]="
            this.consultationWorkflowData.consultation_data.other_data
              .print_data.displayModal
          " [modal]="true" [style]="{ width: '50vw' }">
          <div class="ui-g-12">
            <app-loading type="LOADING_DATA" *ngIf="
                this.consultationWorkflowData.consultation_data.other_data
                  .print_data.api_result.Posting
              ">
            </app-loading>
          </div>
          <ng-container *ngIf="
              !this.consultationWorkflowData.consultation_data.other_data
                .print_data.api_result.Posting &&
              this.consultationWorkflowData.consultation_data.other_data
                .print_data.api_result.PromiseResult.success != null &&
              this.consultationWorkflowData.consultation_data.other_data
                .print_data.api_result.PromiseResult.success
            ">
            <div class="ui-g-12">
              <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text">
              </p-button>
            </div>
            <div *ngIf="
                this.consultationWorkflowData.consultation_data.other_data
                  .print_data.api_result.PromiseResult.success != null &&
                this.consultationWorkflowData.consultation_data.other_data
                  .print_data.api_result.PromiseResult.success
              ">
              <div class="spaces"></div>
              <app-invoicedetails class="notranslate" [data]="
                  this.consultationWorkflowData.consultation_data.other_data
                    .print_data.data
                " [dataId]="
                  this.consultationWorkflowData.consultation_data.other_data
                    .print_data.showInvoice
                ">
              </app-invoicedetails>
            </div>
          </ng-container>
        </p-dialog>
        <div *ngIf="
            this.consultationWorkflowData.consultation_data.other_data
              .print_data.api_result.PromiseResult.success != null &&
            this.consultationWorkflowData.consultation_data.other_data
              .print_data.api_result.PromiseResult.success
          ">
          <div class="spaces"></div>
          <app-invoicedetails class="notranslate" [data]="
              this.consultationWorkflowData.consultation_data.other_data
                .print_data.data
            " [dataId]="
              this.consultationWorkflowData.consultation_data.other_data
                .print_data.printContent
            ">
          </app-invoicedetails>
        </div>
      </ng-container>
      <div class="ui-g-2 ui-sm-12"></div>
      <div class="ui-g-8 ui-sm-12" style="
          padding: 10px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          align-items: center;
        ">
        <ng-container>
          <div class="ui-g">
            <div class="ui-g-12 parent-container" style="text-align: right">
              <i class="pi pi-times" style="cursor: pointer; font-size: 100%; margin-left: auto"
                [routerLink]="['/', this.slug, 'book-appointment']"></i>
            </div>

            <div class="ui-g-8 ui-sm-12">
              <div class="ui-g-12 bdr">
                <div style="display: flex; align-items: center">
                  <img src="../../../../assets/images/ad_landing_page_assets/Icon awesome-check-circle.png" alt="tick"
                    style="width: 30px; height: 30px; margin-right: 15px" />
                  <p class="common_txt" style="font-weight: bold">
                    Your Consultation is booked
                  </p>
                </div>
                <br />
                <div class="ui-g-12">
                  <p class="common_txt">
                    Your Request Number is<span class="notranslate">
                      {{
                      this.consultationWorkflowData.consultation_data.other_data
                      .payment_data.paymentSuccessData.consultationData
                      .consultation_request_number
                      }}</span>
                  </p>
                  <br />
                  <p class="common_txt">
                    Thank you for contacting eGlobalDoctors
                  </p>
                  <br />
                  <p class="common_txt">
                    One of our expert Doctors will reach out to you according to
                    your priority.
                  </p>
                  <br />
                  <p class="common_txt">
                    You can always track your requests in the "Track Request"
                    section of your profile.
                  </p>
                  <br /><br />
                </div>
              </div>
              <div class="ui-g-12 ui-sm-12 common_txt btns" style="display: flex">
                <div class="ui-g-6 ui-sm-6">
                  <button pButton type="button" class="dash_btns" label="Upload & Edit Details" style="
                      margin-bottom: 10px;
                      width: 80%;
                      border-radius: 5px;
                      padding: 10px;
                      word-wrap: break-word;
                      margin-left: 40px;
                    " [routerLink]="['/', this.slug, 'patient', 'uploadandeditdocuments']"></button>
                </div>
                <div class="ui-g-6 ui-sm-6">
                  <button pButton type="button" class="nav_btn" label="Navigate Dashboard" style="
                      margin-bottom: 10px;
                      width: 80%;
                      border-radius: 5px;
                      padding: 10px;
                      background-color: white;
                      color: black;
                      border-color: black;
                      word-wrap: break-word;
                    " [routerLink]="['/', this.slug, 'patient', 'dashboard']"></button>
                </div>
              </div>

              <div class="ui-g-12 ui-sm-12 common_txt invc-btn text-center"
                style="display: flex;justify-content: center;">
                <div class="ui-g-5 ui-sm-5">
                  <button pButton type="button" *ngIf="isPay()" (click)="openInvoice()" style="
                      margin-bottom: 0px 5px 10px 0px;
                      width: 100%;
                      border-radius: 5px;
                      padding: 10px;
                      background-color: white;
                      color: black;
                      border-color: black;
                      word-wrap: break-word;
                      display: flex; 
                      align-items: center; 
                    ">
                    <div style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      ">
                      <span style="margin-right: 5px">Print Invoice</span>
                      <img src="../../../../assets/images/ad_landing_page_assets/Icon payment-invoice-sign-alt.png"
                        style="
                          height: auto;
                          width: auto;
                          max-height: 100%;
                          max-width: 100%;
                        " />
                    </div>
                  </button>
                </div>
              </div>

            </div>
            <div class="ui-g-4 ui-sm-12 visible_screens">
              <div style="
                  display: flex;
                  justify-content: flex-end;
                  align-items: end;
                  margin-right: 5px;
                  margin-top: 5%;
                ">
                <button pButton type="button" *ngIf="isPay()" (click)="openInvoice()" style="
                    margin-bottom: 0px 5px 10px 0px;
                    width: auto;
                    border-radius: 5px;
                    padding: 10px;
                    background-color: white;
                    color: black;
                    border-color: black;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                  ">
                  <span style="flex: 1; margin-right: 5px">Print Invoice</span>
                  <img src="../../../../assets/images/ad_landing_page_assets/Icon payment-invoice-sign-alt.png" style="
                      height: auto;
                      width: auto;
                      max-height: 100%;
                      max-width: 100%;
                    " />
                </button>
              </div>
              <div style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
                <img src="../../../../assets/images/1141 [Converted].png" alt="image"
                  style="max-width: 90%; height: auto" />
                <div class="ui-g-12 text-center">
                  <p class="common_txt" style="font-weight: bold">
                    Highly Secured & <br />
                    Confidential Consultations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>